/**
 * @author lifei
 * 功能：事件、数据中转中心，用于模块解耦等
 */

import { Base } from '../base'

export class EventEmitter<T extends (typeof EventEmitter.eventNames)[number], K extends (...args: any[]) => void> extends Base {
  constructor() {
    super()
  }

  static {
    Base.register(this)
  }

  /**
   * 功能： 事件类型
   */
  private static eventNames = ['API:401', 'API:HEADERS', 'ROUTER:CONFIG'] as const
  /**
   * 功能：保存所有的监听者
   */
  private observers = new Map<T, K[]>()

  /**
   * 功能：事件监听
   * @param eventName 事件名称
   * @param cb 监听的回调函数
   */
  public on = (eventName: T, cb: K): void => {
    const obs = this.observers.get(eventName)
    if (obs) {
      obs.push(cb)
    } else {
      this.observers.set(eventName, [cb])
    }
  }
  /**
   * 功能：仅执行一次
   * @param eventName 事件名
   * @param cb 事件处理函数
   */
  public once = (eventName: T, cb: K): void => {
    this.on(eventName, ((...args: K[]) => {
      cb(...args)
      this.off(eventName)
    }) as K)
  }

  /**
   * 功能：通知
   * @param eventName 事件名称
   * @param args 数据
   */
  public emit = <K>(eventName: T, ...args: K[]): void => {
    const obs = this.observers.get(eventName)
    obs && obs.forEach((cb) => cb(...args))
  }

  /**
   * 功能：删除事件
   * @param eventName 事件名称
   */
  public off = (eventName: T): void => {
    this.observers.delete(eventName)
  }

  /**
   * 功能：清空事件
   */
  public clear = (): void => {
    this.observers.clear()
  }

  /**
   * 功能：获取所有的事件
   */
  public getObservers = (): Map<T, K[]> => this.observers
}

export const eventEmitter = new EventEmitter()
